module.exports = __webpack_public_path__ + "img/example-2.442ab62d.png";